import Axios from "axios";
import { TENANT_ID } from "Constants/tenant";
import qs from "qs";
import { fixDates4Post } from "Utils/";

const API = Axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Access-Control-Allow-Headers": "*",
    "Content-Type": "application/json",
  },
});

API.interceptors.request.use(async (request) => {
  request.params = {
    ...request.params,
    tenantId: TENANT_ID,
  };

  if (["post", "put", "patch"].includes(request.method)) {
    request.data = fixDates4Post(request.data);
  }

  request.paramsSerializer = function (params) {
    return qs.stringify(params, { indices: false });
  };

  await AuthCatcher();
  return request;
});

API.interceptors.response.use(
  (response) => {
    console.groupCollapsed("Response from", response.config.url);

    console.log("response", response);

    console.groupCollapsed("Request Headers ->");
    console.log(response.config.headers);
    console.groupEnd();

    console.groupCollapsed("Response Headers ->");
    console.log(response.headers);
    console.groupEnd();

    // if (response.data.result.resultCode === -1) {
    //   throw response.data.result.resultMessage;
    // }

    if (response.data) {
      console.groupCollapsed("Response Data ->");
      console.log(response.data);
      console.groupEnd();
      console.groupEnd();
      return response.data;
    }

    console.groupEnd();
    return response.data;
  },
  (error) => {
    console.error("Global ERROR -- ", JSON.stringify(error));
    console.error("Global API error handler->", error.response);
    if (error.response && error.response.data) {
      const { data } = error.response;
      const originalRequest = error.config;
      if (data.status === 401 && error.config && !error.config._retry) {
        originalRequest._retry = true;
        RefreshLogic();
        throw new Error("Oturumunuz yenileniyor...");
      }
      GlobalErrorHandler(error.response);
      throw data;
    }
    GlobalErrorHandler(error.response);
    throw error;
  }
);

let GlobalErrorHandler = () => {
  return Promise.resolve(true);
};

let RefreshLogic = () => {
  return Promise.resolve(true);
};

let AuthCatcher = async () => {
  console.log("Auth catcher not set yet.");
};

const SetAuthCatcher = async (fn) => {
  AuthCatcher = () => fn(API);
  return new Promise((resolve, reject) => {
    setTimeout(async () => {
      return resolve(fn(API));
    }, 1000);
  });
};

const SetRefreshLogic = async (fn) => {
  RefreshLogic = fn;
};

const SetGlobalErrorHandler = async (fn) => {
  GlobalErrorHandler = fn;
};

API.SetAuthCatcher = SetAuthCatcher;
API.SetRefreshLogic = SetRefreshLogic;
API.SetGlobalErrorHandler = SetGlobalErrorHandler;

export default API;
